import { useQuery } from '@tanstack/react-query'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import { generateTelevetEmbeddedLink } from '@/services/televet.services'
import {
  TELEVET_QUERY_KEYS,
  CACHE_STALE_TIME,
  CACHE_GC_TIME,
  QUERY_NETWORK_MODE,
} from '@/shared/constants/cache'

export function useTelevetEmbeddedLink() {
  return useQuery<string>({
    queryKey: TELEVET_QUERY_KEYS.embeddedLink,
    queryFn: async () => {
      const token = await getJwt()
      if (!token) throw new Error('No JWT token')
      const { url } = await generateTelevetEmbeddedLink(token)
      return url
    },
    staleTime: CACHE_STALE_TIME,
    gcTime: CACHE_GC_TIME,
    networkMode: QUERY_NETWORK_MODE,
  })
}
